import React, { useEffect, useRef } from "react";

import {
  Grid,
  Paper,
  Typography,
  Divider,
  TextField,
  Checkbox,
  FormControlLabel,
  Switch,
  useTheme,
} from "@material-ui/core";
import { Cities } from "../../config/jobsConfigData";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const AddUpdateCompany = ({ onUpdate, company }) => {
  const theme = useTheme();
  const fullnameRef = useRef(null);
  const companyAddressRef = useRef(null);
  useEffect(() => {
    if (company) {
      fullnameRef.current.value = company.name;
      companyAddressRef.current.value = company.address;
    }
  }, [company]);

  const handleCitiesChange = (event, value, reason) => {
    let cities = [];
    value.forEach((city) => {
      if (!cities.includes(city)) cities = [...cities, city];
    });
    onUpdate("cities", cities);
  };
  return (
    <Paper>
      <Typography variant={"subtitle1"} color="textPrimary">
        General Details
      </Typography>
      <Divider />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            variant="filled"
            fullWidth
            label="Company Name*"
            inputRef={fullnameRef}
            //value={company ? company.name : ""}
            onBlur={(event) => onUpdate("name", event.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            variant="filled"
            fullWidth
            label="Company Address"
            inputRef={companyAddressRef}
            helperText="Company Headquarters"
            defaultValue={company ? company.address : ""}
            onBlur={(event) => onUpdate("address", event.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            multiple
            id="cities-tags"
            options={Cities.map((city) => city.name)}
            disableCloseOnSelect
            //defaultValue={company && company.cities ? company.cities : []}
            //getOptionLabel={(city) => city}
            //getOptionSelected={(option, value) => option.name === value}
            value={company ? company.cities : []}
            limitTags={3}
            fullWidth
            onChange={handleCitiesChange}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: theme.spacing(2) }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="filled"
                label="Cities"
                placeholder="Working City..."
                helperText="Select cities that you want to recruite from"
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={company && company.is_signal}
                //defaultChecked={false}
                onChange={(event) => onUpdate("signal", event.target.checked)}
                name="Signal"
                color="primary"
              />
            }
            label="Signal"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AddUpdateCompany;
